'use client';

import { Flex, IconButton } from '@chakra-ui/react';
import { memo, useCallback } from 'react';
import { LuPlus, LuReplace, LuTrash2 } from 'react-icons/lu';

interface Props {
  nodeId: string;
  isHovered: boolean;
  onAdd: (nodeId: string) => void;
  onReplace: (nodeId: string) => void;
  onDelete: (nodeId: string) => void;
}

const NodeHoverActions = ({ nodeId, isHovered, onAdd, onReplace, onDelete }: Props) => {
  const handleAdd = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onAdd(nodeId);
    },
    [nodeId, onAdd],
  );

  const handleReplace = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onReplace(nodeId);
    },
    [nodeId, onReplace],
  );

  const handleDelete = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      onDelete(nodeId);
    },
    [nodeId, onDelete],
  );

  if (!isHovered) {return null;}

  return (
    <Flex
      position="absolute"
      top="-10px"
      right="-10px"
      gap={1}
      zIndex={10}
    >
      <IconButton
        size="2xs"
        borderRadius="full"
        bg="surface.background"
        borderWidth="1px"
        borderColor="border.light"
        boxShadow="sm"
        color="text.secondary"
        _hover={{ color: 'text.primary', bg: 'surface.hover' }}
        onClick={handleAdd}
        aria-label="Add node after"
      >
        <LuPlus />
      </IconButton>
      <IconButton
        size="2xs"
        borderRadius="full"
        bg="surface.background"
        borderWidth="1px"
        borderColor="border.light"
        boxShadow="sm"
        color="text.secondary"
        _hover={{ color: 'text.primary', bg: 'surface.hover' }}
        onClick={handleReplace}
        aria-label="Replace node"
      >
        <LuReplace />
      </IconButton>
      <IconButton
        size="2xs"
        borderRadius="full"
        bg="surface.background"
        borderWidth="1px"
        borderColor="border.light"
        boxShadow="sm"
        color="text.secondary"
        _hover={{ color: 'red.500', bg: 'red.50' }}
        onClick={handleDelete}
        aria-label="Delete node"
      >
        <LuTrash2 />
      </IconButton>
    </Flex>
  );
};

export default memo(NodeHoverActions);
